//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const TYPES = [
    '全部', '即将预售', '最新取证', '最新摇号', '在售楼盘', '热门楼盘', '热门公寓'
]
export default {
    data () {
        return {
            types: TYPES,
            show_list: false
        }
    },
    methods: {
        toggleList () {
            this.show_list = !this.show_list
        },
        changeType (e) {
            const { type } = e.currentTarget.dataset
            this.$emit('changeType', type)
            this.toggleList()
        }
    },
    props: {
        selected: {
            type: String,
            default: '全部'
        }
    }
}
